export default __webpack_public_path__ + "static/media/logo-black.194c0507.svg";